export default function Logo({ className = "h-10 w-auto" }) {
  return (
    <>
      <img src="/assets/logo-navy.png?v=2" alt="Harrison Litigation Team" className={`${className} dark:hidden`} />
      <img src="/assets/logo-white.png?v=2" alt="" aria-hidden="true" className={`${className} hidden dark:block`} />
    </>
  );
}
